import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=0abf3178&scoped=true&"
import script from "./Tv.vue?vue&type=script&lang=js&"
export * from "./Tv.vue?vue&type=script&lang=js&"
import style0 from "./Tv.vue?vue&type=style&index=0&id=0abf3178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf3178",
  null
  
)

export default component.exports